import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { DictationButton } from "@/features/dictation/DictationButton";

export function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex h-screen bg-cream-50 dark:bg-dark-900">
      <Sidebar collapsed={collapsed} />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar onToggleSidebar={() => setCollapsed((c) => !c)} />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
      {/* Floating dictation button — portal to body, gated on ai.use inside. */}
      <DictationButton />
    </div>
  );
}
